import React, { useState, useEffect, useContext } from 'react';
import Breadcrumb from '../components/Breadcrumb';
import { Link, useSearchParams } from 'react-router-dom';
import { CiEdit } from 'react-icons/ci';
import { FaRegWindowClose } from 'react-icons/fa';
import { RxUpload } from 'react-icons/rx';
import card from '../images/cards/cards-02.png';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { IoSearchSharp } from 'react-icons/io5';
import ReactPaginate from 'react-paginate';
import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
import { format as jalaliFormat, toDate } from 'date-fns-jalali';
import { DataContext } from '../context/DataProvider';
import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import SearchableDropDownFetchParent from '../SearchableDropDown/SearchableDropDownFetchParent';
import { jwtDecode } from 'jwt-decode';
import { MdOutlinePublishedWithChanges } from 'react-icons/md';
import { Editor } from "@ckeditor/ckeditor5-core";
import { UploadAdapter, FileLoader } from "@ckeditor/ckeditor5-upload/src/filerepository";

const NewsManagement = () => {
  const { isTokenExpired, tokenLogin, fetchRefreshToken, ParentId } =
    useContext(DataContext);
  const [AllNews, setAllNews] = useState([]);
  const [savePage, setSavePage] = useState(1);
  const [pageNumber, setPageNumber] = useState(1);
  const [PageType, setPageType] = useState([]);
  const [PageTypeSearch, setPageTypeSearch] = useState(0);
  const [Languege, setLanguege] = useState([]);
  const [ArrayImages, setArrayImages] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [Edit, setEdit] = useState(false);
  const [Title, setTitle] = useState('');
  const [Loading, setLoading] = useState(false);
  const AuthorInfo = jwtDecode(tokenLogin.data.accessToken);
  const [searchParams, setsearchParams] = useSearchParams();
  const [caseData, setCaseData] = useState({
    Title: '',
    Parent_ID: 0,
    ImageUrl: '' || null,
    // Ordering: null,
    PageType_ID: 0,
    Abstract: '',
    Keywords: '',
    HtmlBody: '',
    CreateDate: new Date(),
status:null,
    // ModifiedDate: '',
    Author_ID: 0,
    IsMenu: true,
    Languege_ID: 0,
    ID: 0,
    
  });


  // function uploadPlugin(editor: Editor) {
  //   editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
  //     return uploadAdapter(loader);
  //   };
  // }
  const fetchPageType = async () => {
    await fetch(`${process.env.REACT_APP_BASE_URL}/api/Data/Get?id=8`)
      .then((res) => res.json())
      .then((data) => setPageType(data));
  };
  const fetchLanguege = async () => {
    await fetch(`${process.env.REACT_APP_BASE_URL}/api/Data/Get?id=9`)
      .then((res) => res.json())
      .then((data) => setLanguege(data));
  };
  const [pageSize, setPageSize] = useState(10);
  const page: number | any = searchParams.get('page');
  let rowNumber = page ? (page - 1) * pageSize : 0;
  const [pageCount,setPagecount]=useState(0)
  const [count, setCount] = useState(0);
  const [array, setArray] = useState([]);
  const [Total, setTotal] = useState(0);

const changeStatus=(e)=>{
  console.log(e.target.value)
  if(e.target.value == "null"){
    setCaseData({...caseData,status:null})
  }
  else if (e.target.value == "false"){
    setCaseData({...caseData,status:false})
  }
  else {
    setCaseData({...caseData,status:true})
  }
}



  const GetAllNews = async () => {
    setLoading(true);
    console.log(Title);
    try {
    await fetch(
        `${
          process.env.REACT_APP_BASE_URL
        }/api/Page/GetAll?order=0&size=${pageSize}&page=${
          page == null ? '1' : page
        }${Title !== '' ? '&Title=' + Title : ''}${
          PageTypeSearch !== 0 ? '&PageType_ID=' + PageTypeSearch : ''
        }`,
      )
        .then((res) => res.json())
        .then((data) => {
          setAllNews(data.data);
          setPagecount(data.count)
         
          // setTotal(Math.ceil(sum / pageSize));
        })
        .finally(() => setLoading(false));
    } catch (error) {
      console.log('error', error);
    }
  };
  console.log(Total);
  const GetNewsById = async (id) => {
    const DAte = new Date();
    setArrayImages([])
    fetch(`${process.env.REACT_APP_BASE_URL}/api/Page/GetById?id=${id}`)
      .then((res) => res.json())
      .then((data) =>
        setCaseData({
          Title: data.title,
          Parent_ID: data.parent_ID,
          ImageUrl: data.imageUrl,
          // Ordering: data.Ordering,
          PageType_ID: data.pageType_ID,
          Abstract: data.abstract,
          Keywords: data.keywords,
          HtmlBody: data.htmlBody,
          CreateDate: data.createDate == null ? DAte : data.createDate,
          // ModifiedDate: data.ModifiedDate,
          Author_ID: data.author_ID,
          IsMenu: data.isMenu,
          Languege_ID: data.languege_ID,
          ID: data.id,
          status:data.isPublish
        }),
      )
      .finally(() => {
        setEdit(true);
        setOpenModal(true);
      });
  };

  const OnChangeCKEitor = (editor, event) => {
    let data = event.getData();
    console.log(event.getData());
    setCaseData({
      ...caseData,
      HtmlBody: data,
    });
  };
  const handleUploadIamge = (e) => {
    let x = [];
    let a = [];
    setCaseData({ ...caseData, ImageUrl: e.target.files[0].name });

    // console.log(e.target.files[0]);
    // if (ArrayImages !== null) {
    //   x = [...ArrayImages];

    //   x.push(URL.createObjectURL(e.target.files[0]));
    //   setCount(count + 1);
    // } else {
    //   x.push(URL.createObjectURL(e.target.files[0]));
    // }
    x.push(URL.createObjectURL(e.target.files[0]));
    // a.push(URL.createObjectURL(e.target.files[0].name))
    setArrayImages(x);
  };
  const changeImaege = (index) => {
    console.log(index);
    setCount(index);
  };
  useEffect(() => {
    fetchPageType();
    fetchLanguege();
  }, []);
  useEffect(() => {
    GetAllNews();
  }, [page]);
  const onPageChange = ({ selected }) => {
    setSavePage(selected + 1);
    setsearchParams({ page: selected + 1 });
    setPageNumber(selected + 1);
  

    // FetchLawList(selected+1)
  };
  const EditNews = async () => {
    console.log(ParentId);
    try {
      if (!isTokenExpired(tokenLogin.data?.accessToken)) {
        await fetch(`${process.env.REACT_APP_BASE_URL}/api/Page/Upsert`, {
          method: 'POST',
          headers: {
            Authorization: `Bearer ${tokenLogin.data?.accessToken}`,
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET,OPTIONS,PATCH,DELETE,POST,PUT',
            'Access-Control-Allow-Headers':
              'X-Requested-With, Content-Type, Authorization',
            'Access-Control-Allow-Credentials': 'true',
          },
          body: JSON.stringify({
            ID: caseData.ID,
            Title: caseData.Title,
            Parent_ID: ParentId,
            ImageUrl: caseData.ImageUrl,
            // Ordering: caseData.Ordering,
            PageType_ID: caseData.PageType_ID,
            Abstract: caseData.Abstract,
            Keywords: caseData.Keywords,
            HtmlBody: caseData.HtmlBody,
            CreateDate: caseData.CreateDate,
            // ModifiedDate: caseData.ModifiedDate,
            Author_ID: AuthorInfo.userId,
            IsMenu: caseData.IsMenu,
            Languege_ID: caseData.Languege_ID,
            isPublish:caseData.status
          }),
        }).then((res) => {
          if (res.status === 200) {
            setOpenModal(false);
            GetAllNews();
            alert('اطلاعات با موفقیت ثبت شد ');
          } else {
            alert('خطایی رخ داده لطفا مجدد بررسی کنید');
          }
        });
      } else {
        fetchRefreshToken();
      }
    } catch (error) {
      console.log('error', error);
    }
  };
  const handleFromDate = (date: Date) => {
    const DateTime = new Date(date);

    setCaseData({
      ...caseData,
      CreateDate: DateTime,
    });
  };

  const newNews = () => {
    setCaseData({
      Title: '',
      Parent_ID: 0,
      ImageUrl: '' || null,
      // Ordering: null,
      PageType_ID: 0,
      Abstract: '',
      Keywords: '',
      HtmlBody: '',
      CreateDate: new Date(),
      // ModifiedDate: '',
      Author_ID: 0,
      IsMenu: true,
      Languege_ID: 0,
      ID: 0,
    });
    setEdit(false);
    setOpenModal(true);
  };
  console.log(AllNews)
  if (Loading) return <h1>loading.....</h1>;

  // console.log('bbbbbbb', PageType.find((i)=>i.Value == 1).Item);
  return (
    <>
      <Breadcrumb pageName="مدیریت اخبار " />
      <div className="w-full max-w-full p-10 rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
        <div className="flex items-center w-full">
          <div className=" w-[50%] flex items-center justify-between">
            <input
              onChange={(e) => setTitle(e.target.value)}
              className="border font-IranSans w-[20%] w-full relative border-[#E5E1DA] outline-none p-2 rounded-lg  text-[14px]"
              placeholder="جستجوی خبر"
              defaultValue={Title}
            />
            <select
            defaultValue={PageTypeSearch}
              onChange={(e) => setPageTypeSearch(Number(e.target.value))}
              className="w-[100%] border px-3 py-1 h-10 rounded-lg mr-2 border-[#d1d5db] focus:outline-none"
            >
              <option value="null"></option>
              {PageType.map((item) => {
                return <option value={item.value}>{item.item}</option>;
              })}
            </select>
          </div>
          <div className="w-full flex items-center">
            <button className="buttonsearch mr-3" onClick={GetAllNews}>
              <IoSearchSharp size={35} className="svgIcon " />
            </button>
            <button className=" md:mt-0 mt-3 " onClick={newNews}>
              <span className="box font-IranSans text-[16px]">جدید</span>
            </button>
          </div>
        </div>
        <div className="w-full mt-5">
          <table className="w-full   ">
            <thead>
              {/* <tr
                className="grid grid-cols-4 rounded-t-sm bg-[#B1B2FF] text-[#030637] min-w-[640px] "
                style={{ fontFamily: 'IranSans' }}
              > */}
              <tr className="font-IranSans w-full bg-[#B1B2FF] text-[#030637]">
                <th className="w-10 p-3 text-[14px] text-center">
                  <span className="hidden lg:block "> ردیف </span>
                  <span className="block lg:hidden sm:w-[20%]"> ردیف </span>
                </th>
                {/* <th className="flex h-15 w-[30rem] items-center justify-center p-1 text-2xl font-semibold sm:text-base xl:p-5"> */}
                <th className="w-[30rem]  p-3 text-[14px] text-center">
                  <span className="hidden lg:block"> عنوان</span>
                  <span className="flex bg-red-500 lg:hidden sm:w-[20%]">
                    {' '}
                    عنوان
                  </span>
                </th>
                {/* <th className="flex h-15 w-[]  items-center justify-center p-1 text-2xl font-semibold sm:text-base xl:p-5 "> */}
                <th className="w-20  p-3 text-[14px] text-center">
                  <span className="hidden lg:block"> تاریخ </span>
                  <span className="block lg:hidden sm:w-[20%] "> تاریخ </span>
                </th>

                {/* <th className="flex h-15  items-center justify-center p-1 text-2xl font-semibold sm:text-base xl:p-5"> */}
                <th className="w-20 p-3 text-[14px] text-center">
                  <span className="hidden lg:block"> نوع </span>
                  <span className="block lg:hidden sm:w-[20%]"> نوع </span>
                </th>
              </tr>
            </thead>
            <tbody>
              {AllNews.length !== 0 ? (
                <>
                  {AllNews.map((item) => {
                    return (
                      <>
                        <tr
                          //   className="grid grid-cols-4 text-center "
                          style={{ fontFamily: 'IranSans' }}
                        >
                          <td className="w-10 border-b p-3 text-[14px] text-center">
                            <div className="font-[14px] text-black dark:text-white">
                              {(rowNumber = rowNumber + 1)}
                            </div>
                          </td>
                          <td className="w-[30rem] border-b p-3 text-[14px] text-center">
                            <Link to={`https://ilaws.net/blog/${item.id}`} target='_blank' className=''>
                            <div className=" w-full font-[14px] text-black dark:text-white hover:text-[#06b6d4] cursor-pointer">
                              {item.title}
                            </div>
                            </Link>
                          </td>
                          <td className="w-20 border-b p-3 text-[16px] text-center">
                            <div className="font-[14px] text-black dark:text-white">
                              {item.createDate == null
                                ? item.createDate
                                : jalaliFormat(
                                    new Date(item.createDate),
                                    'yyyy/MM/dd',
                                  )}
                            </div>
                          </td>{' '}
                          <td className="w-20 border-b p-3 text-[14px] text-center">
                            {item.pageType_ID !== null &&
                            PageType.find(
                              (i) => i.value == item.pageType_ID,
                            ) !== undefined ? (
                              <div
                                onClick={() => GetNewsById(item.id)}
                                className="flex items-center justify-center bg-[#06b6d4] hover:border-[#06b6d4] hover:border py-1 rounded-md cursor-pointer hover:bg-white hover:text-[#06b6d4] text-white  dark:text-white"
                              >
                                {PageType.find(
                                  (i) => i.value == item.pageType_ID,
                                ) !== undefined &&
                                  PageType.find(
                                    (i) => i.value == item.pageType_ID,
                                  ).item}
                              </div>
                            ) : (
                              <div
                                onClick={() => GetNewsById(item.id)}
                                className="flex items-center justify-center bg-[#06b6d4] hover:border-[#06b6d4] hover:border py-1 rounded-md cursor-pointer hover:bg-white hover:text-[#06b6d4] text-white  dark:text-white"
                              >
                                <CiEdit className="text-[20px]" />
                              </div>
                            )}
                          </td>
                        </tr>
                      </>
                    );
                  })}
                </>
              ) : (
                <></>
              )}
            </tbody>
          </table>
          <div className="w-full items-center font-IranSans justify-center">
            <ReactPaginate
              breakLabel={<span className="mr-4 sm:mr-0">...</span>}
              nextLabel={
                <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md mr-4 sm:mr-2 sm:p-2">
                  <BsChevronLeft />
                </span>
              }
              onPageChange={onPageChange}
              pageRangeDisplayed={5}
              // pageCount={5}
              pageCount={Math.ceil(pageCount / pageSize)}
              // pageCount={
              //   ListLawCount !== 0 && Math.ceil(ListLawCount / pageSize)
              // }
              previousLabel={
                <span className="w-10 h-10 sm:w-5 sm:h-5 flex items-center justify-center bg-[#D3D3D3] rounded-md">
                  <BsChevronRight />
                </span>
              }
              initialPage={savePage - 1}
              containerClassName="flex items-center justify-center mt-4 mb-4 flex-wrap"
              pageClassName="block border- border-solid border-[#D3D3D3] hover:bg-gray-200 w-10 h-10  flex items-center justify-center rounded-md mr-4"
              activeClassName={
                savePage ? 'bg-[#06b6d4] text-white hover:text-black' : ''
              }
              // current
            />
          </div>
        </div>
        {openModal && (
          <div className="ModalBackground">
            <div className="Modal-newsManage">
              <FaRegWindowClose
                onClick={() => setOpenModal(false)}
                className="mb-2 cursor-pointer"
                size={18}
              />
              <div className="border flex flex-col rounded-md p-5 border[#cbd5e1] font-IranSans">
                {Edit ? (
                  <section className="text-center font-bold">
                    ویرایش خبر{' '}
                  </section>
                ) : (
                  <section className="text-center font-bold">ایجاد خبر</section>
                )}
                <div className="w-full flex items-center  col-span-1 mt-3">
                  <label>عنوان: </label>
                  <input
                    defaultValue={caseData.Title}
                    className="w-full px-3 border py-2 border-[#d1d5db] rounded-lg mr-2 focus:outline-none"
                    onChange={(e) =>
                      setCaseData({ ...caseData, Title: e.target.value })
                    }
                  />
                </div>
                <div className=" mt-2 grid w-full grid-cols-4 gap-3">
                  <div className="flex items-center w-full">
                    <label className="w-[10%]">نوع</label>
                    <select
                      onChange={(e) =>
                        setCaseData({
                          ...caseData,
                          PageType_ID: Number(e.target.value),
                        })
                      }
                      defaultValue={caseData.PageType_ID}
                      className="w-[100%] border px-3 py-1 h-10 rounded-lg mr-2 border-[#d1d5db] focus:outline-none"
                    >
                      <option value="null"></option>
                      {PageType.map((item) => {
                        return <option value={item.value}>{item.item}</option>;
                      })}
                    </select>
                  </div>
                  <div className="flex items-center w-full">
                    <label className="w-[10%]">زبان</label>
                    <select
                      onChange={(e) =>
                        setCaseData({
                          ...caseData,
                          Languege_ID: Number(e.target.value),
                        })
                      }
                      defaultValue={caseData.Languege_ID}
                      className="w-[100%] border px-3 py-1 h-10 rounded-lg mr-2 border-[#d1d5db] focus:outline-none"
                    >
                      <option value="null"></option>
                      {Languege.map((item) => {
                        return <option value={item.value}>{item.item}</option>;
                      })}
                    </select>
                  </div>
                  <div className="w-full flex items-center ">
                    <label className="w-[25%] text-[14px]">تاریخ خبر</label>
                    <DatePicker
                      className="custom-calendar"
                      inputClass="custom-input"
                      calendarPosition="bottom-center"
                      value={
                        caseData.CreateDate !== null &&
                        jalaliFormat(
                          new Date(caseData.CreateDate),
                          'yyyy/MM/dd',
                        )
                      }
                      locale={persian_fa}
                      calendar={persian}
                      onChange={handleFromDate}
                    />
                  </div>
                  <div className="w-full flex items-center ">
                    {caseData.IsMenu ? (
                      <>
                        <label
                          for="default-checkbox"
                          class="ms-2 text-sm font-[16px] text-gray-900 dark:text-gray-300 ml-3"
                        >
                          منو
                        </label>
                        <input
                          defaultChecked
                          onChange={(e) =>
                            setCaseData((caseData) => ({
                              ...caseData,
                              IsMenu: e.target.checked,
                            }))
                          }
                          id="default-checkbox"
                          type="checkbox"
                          value=""
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                        />
                      </>
                    ) : (
                      <>
                        <label
                          for="default-checkbox"
                          class="ms-2 text-sm font-[16px] text-gray-900 dark:text-gray-300 ml-3"
                        >
                          منو
                        </label>
                        <input
                          // defaultChecked
                          onChange={(e) =>
                            setCaseData((caseData) => ({
                              ...caseData,
                              IsMenu: e.target.checked,
                            }))
                          }
                          id="default-checkbox"
                          type="checkbox"
                          value=""
                          className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
                        />
                      </>
                    )}
                  </div>
                </div>
                <div className="grid grid-cols-3 gap-3 mt-5">
                  <div className="w-full h-full flex">
                    <div className="flex  w-full">
                      <label className="mt-2">سرشاخه: </label>
                      {/* <select
                      onChange={(e) =>
                        setCaseData({ ...caseData, Parent_ID: e.target.value })
                         bg-[#ef4444]
                      }
                      className="w-full border py-1 h-10 rounded-lg mr-2 border-[#d1d5db] focus:outline-none"
                    >
                      <option></option>
                      <option></option>
                      <option></option>
                    </select> */}
                      <SearchableDropDownFetchParent
                        ParentID={caseData.Parent_ID}
                      />
                    </div>
                  </div>
                  <div className="w-full h-full text-[14px] flex flex-col">
                    <div className="w-full flex items-center">
                      <label className="text-[14px] w-full">لینک تصویر اصلی </label>
                      {/* <input
                        type="file"
                        className={
                          caseData.ImageUrl == null
                            ? 'file:hidden  px-4 w-full border border-[#d1d5db] py-2 h-10  rounded-lg'
                            : 'relative file:hidden pr-10'
                        }
                        accept="image/*"
                        id="custom-input"
                        onChange={handleUploadIamge}
                      /> */}
                      <input
                        id="custom-input"
                        className= 'px-4 w-full  border border-[#d1d5db]  py-2 h-10 focus:outline-none  rounded-lg'
                        
                        onChange={(e) =>
                          setCaseData({ ...caseData, ImageUrl: e.target.value })
                        }
                        defaultValue={caseData.ImageUrl}
                      />
                      {/* {caseData.ImageUrl == null && (
                        <label for="custom-input" className="px-4 mt-2">
                          <RxUpload className="text-xl" />
                        </label>
                      )} */}
                    </div>
                    {/* {caseData.ImageUrl !== null && (
                      <div className="w-full">
                        <button
                          className=" py-0 rounded-md text-[10px] font-IranSans "
                          onClick={() =>
                            setCaseData({ ...caseData, ImageUrl: null })
                          }
                        >
                          <MdOutlinePublishedWithChanges className="text-lg" />
                        </button>
                      </div>
                    )} */}
                  </div>

                  {/* {caseData.ImageUrl !== null && (
                    <>
                      <div className="w-full grid grid-cols-1 ">
                        <div className=" col-start-1 col-end-7">
                          <img src={ArrayImages[0]} className="object-cover" />
                        </div>
                        {ArrayImages.length > 1 && (
                          <div className=" grid grid-cols-4 gap-1 w-full mt-3">
                            {ArrayImages.map((item, index) => {
                              return (
                                <div>
                                  <img
                                    src={item}
                                    onClick={() => setCount(index)}
                                    className={
                                      count == index
                                        ? 'object-cover w-full h-full cursor-pointer border-[#06b6d4] border-4'
                                        : 'object-cover w-full h-full  cursor-pointer hover:border-[#06b6d4] hover:border-4'
                                    }
                                  />
                                </div>
                              );
                            })}
                          </div>
                        )}
                      </div>
                    </>
                  )} */}
<div className='w-full flex items-center'>
                  <label className='text-[14px] w-[30%]'>وضعیت انتشار</label>
                  <select  onChange={changeStatus} className= 'px-4 w-[70%]  border border-[#d1d5db] text-[14px]  h-10 focus:outline-none  rounded-lg'>
                   {caseData.status==null ? <option selected  value="null">پیش نویس</option>:<option value="null">پیش نویس</option>}
                   {caseData.status == false ?<option selected value="false">عدم انتشار</option>: <option value="false">عدم انتشار</option>}
                   
                    {caseData.status ==true ? <option selected value="true">انتشار</option>: <option value="true">انتشار</option>}
                  </select>
                </div>
                </div>
                
                <div className="mt-2">
                  <label>چکیده</label>
                  <textarea
                    className="w-full border border-[#d1d5db] text-[14px] rounded-lg mt-2 focus:outline-none py-1  px-3"
                    rows="5"
                    cols="30"
                    defaultValue={caseData.Abstract}
                    onChange={(e) =>
                      setCaseData({ ...caseData, Abstract: e.target.value })
                    }
                  ></textarea>
                </div>
                <div className="mt-2">
                  <label>کلمات کلیدی </label>
                  <input
                    defaultValue={caseData.Keywords}
                    onChange={(e) =>
                      setCaseData({ ...caseData, Keywords: e.target.value })
                    }
                    className="w-full border border-[#d1d5db] text-[14px] rounded-lg mt-2 py-2 focus:outline-none  px-3"
                  />
                </div>
                <div className="mt-2">
                  <label>متن خبر </label>
                  <textarea rows={20} cols={5}
                   className='w-full border border-gray-300 rounded-md ltr focus:outline-none px-3 py-4' 
                   defaultValue={caseData.HtmlBody}
                   onChange={(e)=>setCaseData({...caseData,HtmlBody:e.target.value})}
                   />
                  {/* <CKEditor
                    editor={ClassicEditor}
                    data={caseData.HtmlBody}
                    onChange={OnChangeCKEitor}
                    config={{
                      language: 'fa',
                    }}
                    

                  /> */}
                </div>

                <div className="mt-5 w-full ltr">
                  {Edit ? (
                    <button
                      className="w-40 p-2 rounded-full flex items-center justify-center text-[14px] hover:border-2 text-white bg-[#65B741] font-bold 
              hover:shadow-2xl hover:shadow-black "
                      style={{ fontFamily: 'IranSans' }}
                      // type="submit"
                      //   onClick={EditFun}
                      onClick={EditNews}
                    >
                      ویرایش
                      <CiEdit size={20} className="ml-2" />
                    </button>
                  ) : (
                    <button
                      className="w-40 p-2 rounded-full flex items-center justify-center text-[14px] hover:border-2 text-white   bg-[#867AE9]  font-bold 
              hover:shadow-2xl hover:shadow-black "
                      style={{ fontFamily: 'IranSans' }}
                      // type="submit"
                      // onClick={EditFun}
                      onClick={EditNews}
                    >
                      ایجاد
                      <CiEdit size={20} className="ml-2" />
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default NewsManagement;
